import { BusinessInterface } from './business';
import {ListInterface, TagInterface} from "@app/models/util.ts";
import { LinkedMessageTemplate, MessageTemplateContent } from './messageTemplates';

// Custom design stored on an automation (`emailDesigns` rows), one per channel. It's sent instead of the linked template
export type AutomationDesignInterface = MessageTemplateContent & {
  id: string;
  type: 'email' | 'sms';
};

export const AUTOMATION_STATUS_VALUE = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export type AutomationStatusType = typeof AUTOMATION_STATUS_VALUE[keyof typeof AUTOMATION_STATUS_VALUE];


export const AUTOMATION_TYPE_VALUE = {
  REVIEW_REQUEST: 'REVIEW_REQUEST',
  SEND_AUTOMATION: 'SEND_AUTOMATION',
} as const;

export type AutomationTypeType = typeof AUTOMATION_TYPE_VALUE[keyof typeof AUTOMATION_TYPE_VALUE];

export const AUTOMATION_REVIEW_REQUESTS_STATUS_VALUE = {
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  SKIPPED: 'SKIPPED',
} as const;

export type AutomationReviewRequestStatusType = typeof AUTOMATION_REVIEW_REQUESTS_STATUS_VALUE[keyof typeof AUTOMATION_REVIEW_REQUESTS_STATUS_VALUE];

export interface AutomationReviewRequestInterface {
  id: string;
  automationId: string;
  start: string;
  status: AutomationReviewRequestStatusType;

  customerName: string;
  customerEmail: string;
  customerPhone: string;

  schedules: AutomationScheduleInterface[];
  createdAt: string;
  updatedAt: string;
}

export const AUTOMATION_SCHEDULE_TYPE_VALUE = {
  INITIAL: 'INITIAL',
  FOLLOW_UP: 'FOLLOW_UP',
} as const;

export type AutomationScheduleTypeType = typeof AUTOMATION_SCHEDULE_TYPE_VALUE[keyof typeof AUTOMATION_SCHEDULE_TYPE_VALUE];

export const AUTOMATION_SCHEDULE_STATUS_VALUE = {
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  SKIPPED: 'SKIPPED',
} as const;

export type AutomationScheduleStatusType = typeof AUTOMATION_SCHEDULE_STATUS_VALUE[keyof typeof AUTOMATION_SCHEDULE_STATUS_VALUE];

export interface AutomationScheduleInterface {
  id: string;
  automationReviewRequestId: string;
  followUpId: string;
  sendDate: string;
  status: AutomationScheduleStatusType;
  type: AutomationScheduleTypeType;

  createdAt: string;
  updatedAt: string;
}

export const AUTOMATION_EVENT_NAME_VALUE = {
  CUSTOMER_ADDED: 'CUSTOMER_ADDED',
  CUSTOMER_DELETED: 'CUSTOMER_DELETED',
  REVIEW_ADDED: 'REVIEW_ADDED',
  REVIEW_UPDATED: 'REVIEW_UPDATED',
} as const;

export type AutomationEventNameType = typeof AUTOMATION_EVENT_NAME_VALUE[keyof typeof AUTOMATION_EVENT_NAME_VALUE];

export const AUTOMATION_EVENT_SOURCE_VALUE = {
  SYSTEM: 'SYSTEM',
  GOOGLE_REVIEWS: 'GOOGLE_REVIEWS',
  JOBBER: 'JOBBER',
  SQUAREUP: 'SQUAREUP',
} as const;

export type AutomationEventSourceType = typeof AUTOMATION_EVENT_SOURCE_VALUE[keyof typeof AUTOMATION_EVENT_SOURCE_VALUE];

export interface ConditionInterface {
  id: string;
  automationId: string;
  // event: AutomationEventNameType;
  // sources: string[];
  field: string,
  operator: string,
  value?: any,
  createdAt: string;
  updatedAt: string;
}


export interface AutomationInterface {
  id: string;
  name: string;
  description: string;
  channels: string;
  eventName: AutomationEventNameType;
  eventSource: AutomationEventSourceType;
  senderName: string;
  senderAddress: string;
  senderEmail: string;
  createdAt: string;
  updatedAt: string;
  status: AutomationStatusType;
  // customers: CustomerInterface[];
  started: number;
  completed: number;
  reviewRequestsToCancel: number;
  conditions: any[];
  lists: ListInterface[];
  tags: TagInterface[];
  businessId: string;
  business: BusinessInterface;
  emailDesigns?: AutomationDesignInterface[];
  // `null` = the business default template
  emailTemplate?: LinkedMessageTemplate | null;
  smsTemplate?: LinkedMessageTemplate | null;
}

export interface StatusCountsInterface {
  total: number;
  ACTIVE: number | null;
  PAUSED: number | null;
  COMPLETED: number | null;
  CANCELLED: number | null;
  DRAFT: number | null;
}

export interface AutomationsResponseInterface {
  automations: AutomationInterface[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  statusCounts: StatusCountsInterface;
}
//
// export interface CampaignPageDesignInterface {
//   id: string;
//   campaignId: string;
//   type: string;
//   heading: string;
//   description: string;
//   starsColor: string;
//   buttonsColor: string;
//   defaultPlatform: string;
//   tags: string | string[] | null;
//   feedbackInput: string | null;
//   feedbackTextButton: string | null;
//   feedbackReference: string | null;
//   feedbackButtonColor: string | null;
//   imagePath: string | null;
//   positivePlatformTitle: string | null;
//   positiveDescription: string | null;
//   contactEmail: string | null;
//   contactNumber: string | null;
//   additionalPlatforms: any | null;
//   createdAt: string;
//   updatedAt: string;
//   campaign: {
//     id: string;
//     name: string;
//     description: string;
//     channel: string;
//     senderName: string | null;
//     senderAddress: string | null;
//     senderEmail: string;
//     status: string;
//     platforms: string;
//     businessId: string;
//     createdAt: string;
//     updatedAt: string;
//     business?: BusinessInterface;
//   };
// }
//
// export interface CampaignPageDesignsResponseInterface {
//   pageDesigns: CampaignPageDesignInterface[];
//   total: number;
// }
